import { defineStore } from 'pinia'

export const useCache = defineStore('cache', {
  state() {
    return {
      maintenance: false,
      finishCache: null,
      bank: null,
      countries: null
    }
  },

  getters: {
    getMaintenance(state) {
      return state.maintenance
    },
    getFinishCache(state) {
      return state.finishCache
    },
    getBankCache(state) {
      return state.bank
    }
  },

  actions: {
    setFinishCache(payload) {
      this.finishCache = payload
    },
    setBankCache(payload) {
      this.bank = payload
    },
    clearFinishCache() {
      this.finishCache = null
    }
  },

  persist: true
})
